// components/DashboardSidebar.tsx - OPTIMIZED
import { memo, useCallback } from "react";
import { TabButton } from "@/design-system/Atoms/Button/TabButton";
import { Button } from "@/design-system/Atoms";
import { sidebarTabData } from "@/design-system/Molecules/DashboardSidebar/sidebarTab.data";
import { DASHBOARD_TABS } from "@/constants/dashboardTabs";

interface DashboardSidebarProps {
  activeTabId: string;
  onTabChange: (id: string) => void;
}

const DashboardSidebar = memo<DashboardSidebarProps>(({
  activeTabId,
  onTabChange,
}) => {
  const tabData = sidebarTabData(); 
  const requestNurseTab = tabData.find(
    (tab) => tab.id === DASHBOARD_TABS.REQUEST_A_NURSE
  );

  const handleTabClick = useCallback(
    (tab: (typeof tabData)[number]) => {
      if (tab.id === activeTabId) return;  

      onTabChange(tab.id);
      if (tab.onClick) {
        tab.onClick();
      }
    },
    [onTabChange, activeTabId]
  );

  return (
    <aside className="lg:w-4/12">
      <div className="sticky top-0">
        <div className="flex items-start">
          <nav
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
            aria-label="Dashboard navigation"
            className="flex flex-col w-full mr-4 rounded-[20px] bg-[#181a20] p-8 gap-3"
          >
            {tabData
              .filter((tab) => tab.id !== DASHBOARD_TABS.REQUEST_A_NURSE)
              .map((tab) => (
                <TabButton
                  key={tab.id}
                  {...tab}
                  isActive={activeTabId === tab.id}
                  onClick={() => handleTabClick(tab)}
                />
              ))}

            {requestNurseTab && (
              <Button
                variant="secondary"
                size="xl"
                className="hidden md:flex lg:flex mt-4"
                aria-label="Request a nurse service"
                onClick={() => handleTabClick(requestNurseTab)}
              >
                {requestNurseTab.label}
              </Button>
            )} 
          </nav>
        </div>
      </div>
    </aside>
  );
});

DashboardSidebar.displayName = "DashboardSidebar";

export default DashboardSidebar;